export default "__VITE_ASSET__CkIQriEL__"